<template>
    <v-snackbar v-model="snackbar" bottom="bottom" v-bind:timeout="timeout">
        {{ snackbarMessage }}
    </v-snackbar>
</template>

<script>
export default {
    data() {
        return {
            snackbar: false,
            snackbarMessage: '',
            timeout: 5000
        }
    },
    created() {
        this.$store.watch(
            (state) => state.snack,
            () => {
                const message = this.$store.state.snack
                if (message !== '') {
                    this.snackbar = true
                    this.snackbarMessage = message
                    this.$store.commit('setSnack', '')
                }
            }
        )
    }
}
</script>

<style></style>
